module.exports = __webpack_public_path__ + "static/media/AppDownload 2.7957f24c.svg";